import React, { useCallback, useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from '../components/ui/sonner';
import './sales.css';
import { SalesI18nProvider, useT } from './salesI18n';
import { SalesAuthProvider, useSalesAuth } from './SalesAuthContext';
import SalesLogin from './SalesLogin';
import SalesLayout from './SalesLayout';
import DashboardPage from './pages/DashboardPage';
import LeadsPage from './pages/LeadsPage';
import LeadDetailPage from './pages/LeadDetailPage';
import AgendaPage from './pages/AgendaPage';

const Splash = () => (
  <div className="min-h-[100dvh] flex items-center justify-center">
    <div className="h-12 w-12 rounded-full bg-teal-600/80 animate-pulse shadow-lg" data-testid="sales-splash" />
  </div>
);

function Shell() {
  const { user } = useSalesAuth();
  if (user === null) return <Splash />;
  if (user === false) return <SalesLogin />;
  return (
    <Routes>
      <Route element={<SalesLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="leads/:id" element={<LeadDetailPage />} />
        <Route path="agenda" element={<AgendaPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function WithAuth() {
  const { setLang } = useT();
  const onLanguage = useCallback((l) => { if (l === 'en' || l === 'pt-BR') setLang(l); }, [setLang]);
  return (
    <SalesAuthProvider onLanguage={onLanguage}>
      <Shell />
    </SalesAuthProvider>
  );
}

const SALES_ICONS = [['icon', '/sales-icon-32.png', '32x32'], ['icon', '/sales-icon-192.png', '192x192'], ['apple-touch-icon', '/sales-apple-icon-180.png', '180x180']];

export default function SalesPortal() {
  useEffect(() => {
    document.documentElement.classList.add('sales-theme');
    document.title = 'PM Vendas · Sales Portal';
    const base = process.env.PUBLIC_URL || '';
    const old = [...document.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]')];
    old.forEach((l) => l.remove());
    const added = SALES_ICONS.map(([rel, href, sizes]) => {
      const l = document.createElement('link');
      l.rel = rel; l.href = `${base}${href}`; l.sizes = sizes; if (rel === 'icon') l.type = 'image/png';
      document.head.appendChild(l);
      return l;
    });
    return () => { document.documentElement.classList.remove('sales-theme'); added.forEach((l) => l.remove()); old.forEach((l) => document.head.appendChild(l)); };
  }, []);

  return (
    <SalesI18nProvider>
      <BrowserRouter basename="/sales">
        <WithAuth />
        <Toaster richColors position="top-center" closeButton duration={3500} expand visibleToasts={3} />
      </BrowserRouter>
    </SalesI18nProvider>
  );
}
